export default "__VITE_ASSET__CKh5QI0o__"